export const environment = {
  production: false,
  apiUrl: 'https://classics-carmotions.com/api/'
  // apiUrl: 'https://cla-2ue.xava.cloud/'
  // apiUrl: 'http://localhost:8080/'
};
